import { on, reducer } from "ts-action";

import {
  loadBodenrichtwerte,
  loadGebietDrucksachen,
  loadGebietZahlen,
  loadVergleich,
  loadWahllokale,
  type GebietDrucksachen,
} from "./gebiet-actions.js";
import type {
  GebietBoden,
  GebietZahlen,
  VergleichsZeilen,
  Wahllokale,
} from "../service/gebiet-service.js";

export interface GebietState {
  drucksachen?: GebietDrucksachen;
  zahlen?: GebietZahlen;
  wahllokale?: Wahllokale;
  vergleich?: VergleichsZeilen;
  boden?: GebietBoden;
}

export const initialGebietState: GebietState = {};

/**
 * Der Zustand hält NUR das Ergebnis, nicht den Ladezustand — den führen die
 * zentralen Loading-Effects. Und er hält es samt Bezirk: Wer schnell zwischen
 * zwei Profilen wechselt, soll keine fremde Liste unter der eigenen
 * Überschrift sehen.
 */
export const gebietReducer = reducer<GebietState>(
  initialGebietState,
  on(loadGebietDrucksachen.success, (state, { payload }) => ({
    ...state,
    drucksachen: payload,
  })),
  on(loadGebietZahlen.success, (state, { payload }) => ({
    ...state,
    zahlen: payload,
  })),
  on(loadWahllokale.success, (state, { payload }) => ({
    ...state,
    wahllokale: payload,
  })),
  on(loadVergleich.success, (state, { payload }) => ({
    ...state,
    vergleich: payload,
  })),
  on(loadBodenrichtwerte.success, (state, { payload }) => ({
    ...state,
    boden: payload,
  })),
);
